var parent = require('../../es/reflect/construct');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/reflect/construct.js
// module id = 1133
// module chunks = 0